import { Skeleton } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import dummyProductItemImg from "../../../../../Assets/BillingImages/emptyFoodImg.svg";
import ComboPriceTag from '../../SpecialItems/components/ComboPriceTag';
import useProducts from '../Utilities/useProducts';
import { errorSnackMsg } from '../../../../Custom Hooks/SnackkBarUtilities';
import BarcodeReader from "react-barcode-reader";
import CachedImage from '../../../../../offline/components/CachedImage';

const ProductsList = ({ addToCart, isLoading, selectedCategory, specialItemCat, isProductAllowedForDevice }) => {
    const decimalPosition = localStorage.getItem('decimalPosition');
    const userInfo = useSelector((state) => state.loginResponseSlice.value);
    const { productsList, productType } = useSelector((state) => state.newBillingSlice);
    const { tableLoading } = useSelector((state) => state.mainDashBoardSlice);
    const { searchBarInput } = useSelector((state) => state.topBarSliceBilling);
    const { selectedPOSCategory } = useSelector((state) => state.billingScreenSlice);
    const { data, loading } = useProducts({ branchId: userInfo?.branchPk, isPos: true });
    const posSettings = useSelector((state) => state.posSettingSlice.apiResList);
    const customerPaymentStatus = posSettings?.customerStatus;

    const billingItemCardView = (posSettings?.billingItemCardView || localStorage.getItem('billingItemCardView') || 'filled');
    const billingItemCardSize = (posSettings?.billingItemCardSize || localStorage.getItem('billingItemCardSize') || 'large');

    const [filteredData, setFilteredData] = useState([]);


    // Barcode lookup map
    const productMapForBarcode = new Map();
    const productsArray = Array.isArray(data) ? data : [];
    productsArray.forEach(product => {
        if (product.barcode) productMapForBarcode.set(product.barcode, product);
    });
    // Barcode scanner handler
    const onBarcodeScan = (barcode) => {
        const product = productMapForBarcode.get(Number(barcode));
        if (product) {
            addToCart(product);
        } else {
            errorSnackMsg("Product not found!!");
        }
    };

    // Filter logic based directly on data (no memoized maps)
    useEffect(() => {
        const sourceData = specialItemCat ? productsList : data;
    
        console.log('🔍 ProductsList filtering:', {
            selectedCategory,
            selectedPOSCategory,
            totalProducts: sourceData?.length || 0
        });
    
        // Ensure sourceData is an array
        if (!sourceData || !Array.isArray(sourceData) || sourceData.length === 0) return;
    
        // Get today's weekday in lowercase short form (e.g. "mon")
        const today = new Date()
            .toLocaleDateString('en-US', { weekday: 'short' })
            .toLowerCase(); // returns values like 'mon', 'tue', etc.
    
        const lowerSearchQuery = searchBarInput?.toLowerCase();
    
        const filtered = sourceData.filter(product => {
            // Device restrictions DON'T apply to special items/combo offers
            // Only check device restrictions for regular products (not special items)
            if (!specialItemCat && isProductAllowedForDevice && !isProductAllowedForDevice(product)) {
                return false;
            }
            
            const matchesSearch = lowerSearchQuery
                ? product?.productName?.toLowerCase().includes(lowerSearchQuery)
                : true;
    
            const matchesCategory = selectedCategory
                ? product?.mainCatgeoryId === selectedCategory
                : true;
    
            const matchesSubCategory = selectedPOSCategory
                ? product?.poscat === selectedPOSCategory
                : true;
                if (specialItemCat === "combo") {
            const weekdays = product?.weekdays || [];
            const normalizedWeekdays = weekdays.map(day => day.toLowerCase());
    
            const matchesDay = normalizedWeekdays.includes(today) || normalizedWeekdays.includes('daily');
    
            return matchesSearch && matchesCategory && matchesSubCategory && matchesDay;}
            return matchesSearch && matchesCategory && matchesSubCategory;
        });
    
        console.log('  ✅ Filtered result:', filtered.length, 'products');
        setFilteredData(filtered);
    }, [
        searchBarInput,
        selectedCategory,
        selectedPOSCategory,
        data,
        productsList,
        specialItemCat,
        loading,
        isLoading,
        tableLoading
    ]);
    

    const renderSkeletons = (count) => (
        [...Array(count)].map((_, i) => (
            <div key={i} className="billing-single-product-container">
                <Skeleton width="100%" height="100px" />
                <Skeleton width="100%" height="20px" />
                <div className="billing-product-list-select-container">
                    <Skeleton width="60%" height="20px" />
                    <Skeleton width="30%" height="30px" />
                </div>
            </div>
        ))
    );

    return (
        <div className='cards'>
            {(loading || isLoading) ? (
                renderSkeletons(10)
            ) : filteredData.length !== 0 ? (
                filteredData.map((product, index) => (
                    <div
                        className={`card-content billing-item-card billing-item-card--${billingItemCardView} billing-item-card--${billingItemCardSize}`}
                        key={index}
                        onClick={() => addToCart(product)}
                        style={{ maxHeight: "fit-content" }}
                    >
                        <div className="billing-item-card__image">
                        <CachedImage
                            src={product?.imageUrl && product?.imageUrl.length !== 0
                                ? product?.imageUrl
                                : dummyProductItemImg}
                            alt="No Img"
                            className="billing-product-image"
                        />
                        </div>
                        <div className="card-details">
                            <h1>{product.productName}</h1>
                            {productType === 3 ? (
                                product?.productList?.map((item, i) => (
                                    <p style={{ display: "flex", flexWrap: "wrap" }} key={i}>
                                        <span style={{ overflow: "hidden" }}>{item?.productName}</span>
                                        <span style={{ marginLeft: "auto" }}>{item.qty}</span>
                                    </p>
                                ))
                            ) : (
                                <p>{product.salesPrice?.toFixed(decimalPosition)}</p>
                            )}
                        </div>
                        {productType === 3 && (
                            <div className="offer-price" style={{ right: "0px" }}>
                                <ComboPriceTag
                                    amount={product.salesPrice?.toFixed(decimalPosition)}
                                />
                            </div>
                        )}
                    </div>
                ))
            ) : (
                <div className="center-div" style={{ height: "61vh" }}>
                    No Products Available !!
                </div>
            )}
            {tableLoading && renderSkeletons(10)}

            <BarcodeReader onScan={onBarcodeScan} />
        </div>
    );
}

export default ProductsList;
